document.addEventListener('DOMContentLoaded', () => {

    console.log("hero video toggle script loaded");
    const hero = document.querySelector('#hero');
    if (!hero) return;

    console.log("hero video toggle: her element found");

    const video = hero.querySelector('video.hero-video');
    const toggle = hero.querySelector('.hero-video-toggle');

    if (!video || !toggle) return;

    // Ensure initial state
    video.muted = true;

    toggle.addEventListener('click', () => {
        console.log("hero video toggle: toggle clicked");
    video.muted = !video.muted;

    if (video.muted) {
        toggle.setAttribute('aria-pressed', 'true');
        toggle.setAttribute('aria-label', 'Turn sound on');
    } else {
        toggle.setAttribute('aria-pressed', 'false');
        toggle.setAttribute('aria-label', 'Turn sound off');
    }
    });
});